import { mapGetters } from 'vuex';
import PDFButtonBase from '@/components/PDFButton/Base.vue';
import api from '@/api';

export default {
  mixins: [
    PDFButtonBase,
  ],
  computed: {
    ...mapGetters('Client', [
      'client',
    ]),
    clientId() {
      return this.client.id;
    },
  },
  methods: {
    fetchPDF() {
      return api.resource.earlyBirdEnrollmentPacket(this.clientId);
    },
  },
};
